import { PlanFeatures } from "../auth/planProvider/PlanProvider.types";
import { PermissionListType } from "../roles/rolePermissionDialog/RolePermissionDialog.types";

// Declared in menu order, which is not value order: the Dashboard group got a new value when it replaced the single
// Dashboard item, but it still comes first.
export enum NavigationMenuItem {
    Dashboard = 12,
    Frameworks = 2,
    Processes = 3,
    ProcessTemplates = 4,
    Systems = 5,
    Risk = 6,
    Contracts = 7,
    TaskManagement = 8,
    Documentation = 9,
    LegalEntities = 10,
    AuditsAndAssessments = 11,

    // Was the single Dashboard item before the dashboards became a group. It keeps its value so customers who hid
    // that item keep the overview hidden.
    DashboardOverview = 1,
    ContractDashboard = 121,

    ProcessingActivities = 31,
    Record = 32,

    Tasks = 81,
    AnnualWheel = 82,
    Activities = 83,

    Policies = 91,
    IncidentLog = 92,

    ExternalLegalEntities = 101,
    GroupEntities = 102,

    ExternalAudits = 111,
    InternalAssessments = 112,
}

export interface NavigationMenuItemDefinition {
    labelKey: string;
    parent?: NavigationMenuItem;
    // The role permission area the item's pages are governed by, so the role editor can say the area is hidden
    // from the menu. Null for items without an area of their own (Dashboard, and parents whose sub items carry it).
    permissionListType: PermissionListType | null;
    isAvailable: (planFeatures: PlanFeatures, isFeatureFlagEnabled: (featureFlag: string) => boolean) => boolean;
}

export interface NavigationMenuSettingsSaveModel {
    hiddenNavigationMenuItems: Array<NavigationMenuItem>;
}
